export class ContactAddress {

    street: string;
    postalCode: string;
    state: string;
    city: string;
    country: string;
    plus4Code: string

    constructor(street: string,
        postalCode: string,
        state: string,
        city: string,
        country: string,
        plus4Code: string
        ) {
        this.street = street;
        this.postalCode = postalCode;
        this.state = state;
        this.city = city;
        this.country = country;
        this.plus4Code = plus4Code;
    }
}
